var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H19.459V19.459H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.459,
    height: 2.595,
    y: 16.865,
    fill: "#000000",
    fillRule: "nonzero",
    rx: 1.297
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M6.142 8.148c-.54-.538-1.414-.538-1.954 0-.54.539-.539 1.41 0 1.949l4.89 4.877c.36.36.944.359 1.304 0l4.889-4.877c.54-.539.54-1.41 0-1.949-.54-.538-1.414-.538-1.954 0l-2.218 2.214V1.485c0-.76-.619-1.377-1.382-1.377-.763 0-1.382.617-1.382 1.377v8.851L6.142 8.148z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBox);
export default __webpack_public_path__ + "static/media/download-box.78216b7d.svg";
export { ForwardRef as ReactComponent };